module.exports = "<div class=\"crud-table\">\n  <table ng-table-dynamic=\"$ctrl.tableParams with $ctrl.columns\" class=\"table table-striped table-hover table-responsive\">\n    <tr ng-repeat=\"row in $data\">\n      <td ng-repeat=\"col in $columns\">\n        <span class=\"{{(row[col.field] | typeof) == 'number' ? 'pull-right' : ''}}\">\n          {{ (row[col.field][col.subfield] || row[col.field]) | formatDecimal:2 | datetime:'convert' }}\n        </span>\n      </td>\n    </tr>\n  </table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/core/util/c-components/c-table/c-table.html
// module id = 694
// module chunks = 0